module.exports = __webpack_public_path__ + "img/Atlantis.b8cb89b9.png";